import { render, staticRenderFns } from "./NotePreview.vue?vue&type=template&id=19cdfbae&"
import script from "./NotePreview.vue?vue&type=script&lang=js&"
export * from "./NotePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports